/**
 * @file
 * discovercard script.
 */

(function discovercardScript($, Drupal) {
  'use strict';
  Drupal.behaviors.discovercard = {
    attach: function (context) {
      const ctaButton = $('.discover-card__cta', context);

      ctaButton.hover(
        function () {
          const bgColor = $(this).css('border-top-color');
          const textColor = $(this).parents('.discover-card').css('background-color');
          $(this).css('background-color', bgColor);
          $(this).css('color', textColor);
        }, function () {
          const textColor = $(this).parents('.discover-card').css('color');
          $(this).css('background-color', 'transparent');
          $(this).css('color', textColor);
        }
      );
    }
  };
})(jQuery, Drupal);
